import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import { StoreListingTable } from '../../modules/store-listing';

export const StoreListingPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'storeListing.title' })}
      </PageTitle>
      <StoreListingTable />
    </>
  );
};
